<template>
  <div class="w-100 page__wrapper">
    <b-navbar class="navbar" toggleable="lg" type="dark" variant="info">
      <b-navbar-brand href="#" @click="step = 0" class="font-weight-bold py-0">
        <b-img src="@/assets/images/logo_white.png" class="logo" fluid alt="alveolar"></b-img>
      </b-navbar-brand>
    </b-navbar>
    <div class="d-lg-flex h-100 w-100 p-4 align-items-center">
      <div class="d-lg-flex w-100 align-items-center">
        <div class="col-12 col-lg-6 h-100 d-flex flex-column justify-content-center px-0 px-lg-3 mb-4 mb-lg-0">
          <product-selector v-model="selectedProduct"/>
          <b-img class="mt-5 cover-image hidden d-lg-block" :src="productCover" fluid alt="Cover"></b-img>
        </div>
        <div class="col-12 col-lg-6 h-100 d-flex justify-content-center flex-column p-2 p-lg-5 rounded bg-light">
          <div v-if="!step">
            <h2 class="text-info text-center">
              {{ $t('label.selectAProduct') }}
            </h2>
            <h6 class="text-center mt-5">{{ $t('label.selectAProductDescription') }}</h6>
            <b-button :disabled="!selectedProduct" @click="step++" class="mt-5" block variant="info">{{ $t('label.start') }}</b-button>
          </div>
          <template v-if="step === 1 && formComponent">
            <component class="form__container" v-if="formComponent" :is="formComponent" v-model="formModel" :errors="validator.errors" />
            <b-button @click="goToContactForm" class="mt-5" block variant="info">{{ $t('label.quotation') }}</b-button>
          </template>
          <template v-if="formComponent && step === 2">
            <b-link class="mb-3 d-inline-block" @click="step--">{{ $t('label.back') }}</b-link>
            <contact-form ref="contactForm" v-model="formModelContact"/>
            <b-button :disabled="!isValidContactForm" @click="onsubmit" class="mt-5" block variant="info">{{ $t('label.quotation') }}</b-button>
          </template>
        </div>
      </div>
    </div>
    <b-toast />
  </div>
</template>
<script>
import { camelCase, upperFirst } from 'lodash'
import ProductSelector from '../components/ProductSelector'
import ContactForm from '../components/ContactForm'
import { ContactFormModel } from '../forms/ContactFormModel'

export default {
  name: 'HomePage',
  components: {
    ProductSelector,
    ContactForm
  },
  data () {
    return {
      step: 0,
      selectedProduct: null,
      formComponent: null,
      formModel: null,
      validator: null,
      formModelContact: new ContactFormModel(),
      productImageFolder: null
    }
  },
  watch: {
    async selectedProduct (product) {
      this.productImageFolder = product
      const parsedProductName = upperFirst(camelCase(product))
      const FormModel = await import('../forms/' + parsedProductName + 'FormModel')
      const Validator = await import('../validators/products/' + parsedProductName + 'Validator')
      this.formComponent = () => import('../components/products/' + parsedProductName + '.vue')
      // eslint-disable-next-line new-cap
      this.formModel = new FormModel.default()
      // eslint-disable-next-line new-cap
      this.validator = new Validator.default(this.formModel)

      if (this.step === 2) {
        this.step--
      }
    }
  },
  computed: {
    productCover () {
      if (!this.step) {
        return require('../assets/images/default-cover.png')
      } else if (this.step === 1) {
        return require(`../assets/images/${this.productImageFolder}/cover.png`)
      }
      return require('../assets/images/loading-box.png')
    },
    isValidContactForm () {
      return !this.$refs?.contactForm?.$v.value.$invalid
    }
  },
  methods: {
    toBase64 (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    },
    async onsubmit () {
      const hasFileImage = this.formModel.printing && this.formModel.printing.file
      this.$refs.contactForm.$v.value.$touch()

      if (this.$refs.contactForm.$v.value.$invalid) {
        return
      }

      if (hasFileImage) {
        this.formModel.printing.file = await this.toBase64(this.formModel.printing.file)
      }

      this.$bvToast.toast(this.$t('label.quotationSentTitle'), {
        title: this.$t('label.quotationSent'),
        variant: 'success',
        solid: true
      })

      const postData = {
        product: this.formModel,
        contact: this.formModelContact
      }

      fetch('https://cartonificiocampano.com/m.php', {
        method: 'POST', // or 'PUT'
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(postData)
      })
        .then(response => response.json())
        .then(data => {
          console.log('Success:', data)
        })
        .catch((error) => {
          console.error('Error:', error)
        })
    },
    goToContactForm () {
      this.validator.validate()
      if (this.validator.isValid) {
        this.step++
      }
    }
  }
}
</script>
<style lang="scss">
  body, html {
    height: 100%;
    width: 100%;
  }

  .navbar {
    height: 64px;
  }

  .page__wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;

    @media(min-width: 928px) {
      height: 100%;
    }
  }

  .custom-control {
    padding-left: 30px !important;
  }

  .form__container {
    @media(min-width: 928px) {
      overflow-y: scroll;
      height: 400px;
    }
  }

  .cover-image {
    object-fit: contain;
    max-height: 100px;

    @media(min-width: 768px) {
      max-height: 400px;
    }

  }

  .logo {
    width: 160px;
    margin-top: -4px;

    @media(min-width: 768px) {
      margin-top: 0;
    }
  }
</style>
